export default "__VITE_ASSET__630FWg5k__"